import type { ReactNode } from "react";

interface TabContentWrapperProps {
  readonly children: ReactNode;
}

export function TabContentWrapper({ children }: TabContentWrapperProps) {
  return <div className="w-full p-lg sm:p-3xl @container">{children}</div>;
}
